import * as pages from './page-names';

export const homeRoute = '/' + pages.homePageName;

export const changePasswordRoute = '/' + pages.changePasswordPageName;
export const forgotPasswordRoute = '/' + pages.forgotPasswordPageName;
export const editProfileRoute = '/' + pages.editProfilePageName;
export const loginRoute = '/' + pages.loginPageName;
export const userManagementRoute = '/' + pages.userManagementPageName;
export const dynamicUserManagementRoute = '/' + pages.dynamicUserManagementPageName;  // TODO: Remove when dynamic user management is implemented
export const userEditRoute = '/' + pages.userEditPageName;
export const clientAdministrationRoute = '/' + pages.clientAdministrationPageName;
export const dynamicClientAdministrationRoute = '/' + pages.dynamicClientAdministrationPageName; // TODO: Remove when dynamic client administration is implemented
export const themeShowcaseRoute = '/' + pages.themeShowcasePageName;
export const runningTotalsRoute = '/' + pages.runningTotalsPageName;
export const tripOverviewRoute = '/' + pages.tripOverviewPageName;
export const statisticEventsRoute = '/' + pages.statisticEventsPageName;
export const diagnosticEventsRoute = '/' + pages.diagnosticEventsPageName;
export const periodicStatisticsRoute = '/' + pages.periodicStatisticsPageName;
export const samplingProfilesRoute = '/' + pages.samplingProfilesPageName;
export const vehiclesRoute = '/' + pages.vehiclesPageName;
